// extracted by mini-css-extract-plugin
export default {"error":"error_error__1NRW8","errorL":"error_errorL__09oFv","errorL2":"error_errorL2__xfXiC","errorImg":"error_errorImg__Qvzm5"};